import { z } from 'zod';
import { baseSchema, baseObjectSchema } from '../baseSchemas';
export const priceCatalogSchema = baseObjectSchema.extend({
  id: z.string(),
  name: z.string(),
  code: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  includeVat: z.boolean(),
  companyId: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  deleted: z.boolean(),
  company: baseSchema.optional(),
});

export const getPriceCatalogsSchema = z.array(priceCatalogSchema);

export type GetPriceCatalogsResponse = z.infer<typeof getPriceCatalogsSchema>;
